// Dependencias generales
import React from "react";
import { useEffect } from 'react';

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var rulesCommonJS = require("../../js/rulesCommon.js")

// DASHBOARD
const Action = (params) => {
  
  useEffect(() => {           
    console.log("Bloque de acción cargado correctamente.")

    cargarBloqueAcciones() 
    actualizarAccionesDisponibles()                  

    if(params.actionInfo.action !== ""){ 
      setearValoresAccion() 
    }

  });

  function cargarBloqueAcciones(){

    var bloqueGrupoAccionesTemp = ""

    if( (Object.keys(params.objDatosDashboard.FVData).length > 0) && (params.objDatosDashboard.FVData.Application ==="TESLA") ){ bloqueGrupoAccionesTemp += '<option value="Paneles">Paneles</option>' }
    if( (Object.keys(params.objDatosDashboard.BatteriesData).length > 0) && (params.objDatosDashboard.BatteriesData.Application ==="TESLA") ){ bloqueGrupoAccionesTemp += '<option value="Baterias">Baterías</option>' }
    if(Object.keys(params.objDatosDashboard.GeneratorData).length > 0){ bloqueGrupoAccionesTemp += '<option value="GrupoElectrogeno">Grupo electrógeno</option>' }
    if(params.objDatosDashboard.CarsData.length > 0){ bloqueGrupoAccionesTemp += '<option value="Coche">Coche</option>' }
    if(params.objDatosDispositivos.length > 0){ bloqueGrupoAccionesTemp += '<option value="Dispositivos">Dispositivos inteligentes</option>' }
    
    //A priori lo dejo fijo a falta de implementar el envio por email y controlar dinámico si tengo cuenta telegram
    bloqueGrupoAccionesTemp += '<option value="Mensajeria">Mensajería</option>'

    if(!localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
      bloqueGrupoAccionesTemp += '<option value="RegistroActividad">Registro de actividad</option>'
    }    

    // SEGUIR CON LA LÓGICA PARA EL RESTO DE GRUPOS DE ARRIBA

    document.getElementById("selectBloquesAcciones"+params.actionInfo.actionId).innerHTML = bloqueGrupoAccionesTemp

    if(bloqueGrupoAccionesTemp !== ""){
      document.getElementById("selectBloquesAcciones"+params.actionInfo.actionId).selectedIndex = 0;
      actualizarAccionesDisponibles()
    }
    else{
      //Pensar qué hago si no tengo ningún grupo de acciones.... ¿Mensaje informativo ocultando el formulario entero tipo "debe agregar dispositivos o algo para poder crear reglas."?
    }

  }

  function actualizarAccionesDisponibles(){

    var listadoAcciones = ""
    var categoriaAccion = document.getElementById("selectBloquesAcciones"+params.actionInfo.actionId).value
    
    document.getElementById("mensajeInformativoAccion"+params.actionInfo.actionId).className = document.getElementById("mensajeInformativoAccion"+params.actionInfo.actionId).className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("fieldsetAcciones"+params.actionInfo.actionId).className = document.getElementById("fieldsetAcciones"+params.actionInfo.actionId).className.replaceAll(" hidden", "")

    if(categoriaAccion === "Paneles"){
			listadoAcciones =  "<option value=\"postTeslaCommand|forzarVentaExcedente|"+params.objDatosDashboard.FVData.FVId+"|on\">Activar forzado de venta de excedente</option>"      
      listadoAcciones += "<option value=\"postTeslaCommand|forzarVentaExcedente|"+params.objDatosDashboard.FVData.FVId+"|off\">Desactivar forzado de venta de excedente</option>"
    }
    else if(categoriaAccion === "Baterias"){
			listadoAcciones =  "<option value=\"postTeslaCommand|modificarCargaBateriasDeRed|"+params.objDatosDashboard.BatteriesData.BatteryId+"|on\">Activar carga de baterías desde la red</option>"      
      listadoAcciones += "<option value=\"postTeslaCommand|modificarCargaBateriasDeRed|"+params.objDatosDashboard.BatteriesData.BatteryId+"|off\">Desactivar carga de baterías desde la red</option>"
	  }else if(categoriaAccion === "GrupoElectrogeno"){
			listadoAcciones = "<option value=\"updateTankLevelFull\" >Poner el depósito de combustible del grupo al 100%</option>"
	  }else if(categoriaAccion === "Coche"){

      var comandoAccion = ""
      var comandoUpdate = ""

      if(JSON.parse(localStorage.getItem("lastDashboardData")).CarsData[0].Application === "TESLA"){
        comandoAccion = "postTeslaCommand"
        comandoUpdate = "updateTeslaData"
      }

      if ( (localStorage.getItem("lastDashboardData")!== null) && (JSON.parse(localStorage.getItem("lastDashboardData")).CarsData[0].ChargesInInstallation === "true") ){        
        
        listadoAcciones = 
				"<option value=\""+comandoAccion+"|iniciarCarga\" selected>Poner a cargar</option>"+ 
				"<option value=\""+comandoAccion+"|pararCarga\">Parar de cargar</option>"+
				"<option value=\""+comandoAccion+"|modificarAmperajeCarga\">Modificar amperaje de carga</option>"+
				"<option value=\""+comandoUpdate+"\">Actualizar la información del coche</option>"				  
      }
      else{
        listadoAcciones = "<option value=\""+comandoUpdate+"\">Actualizar la información del coche</option>"				  
      }

			
	
    }else if(categoriaAccion === "Dispositivos"){	
      
      var funcionEjecucion = ""

      for(var x=0; x < params.objDatosDispositivos.length; x++) {        
          
        funcionEjecucion = ""

        if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "EWELINK"){funcionEjecucion="postEwelinkCommand"}
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "TPLINK"){funcionEjecucion="postTPLINKCommand"}          
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "SMARTLIFE"){funcionEjecucion="postSMARTLIFECommand"}          
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "TUYA"){funcionEjecucion="postTUYACommand"}          
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "ARISTON"){funcionEjecucion="postARISTONCommand"}          
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "BRONPI"){funcionEjecucion="postBRONPICommand"}         
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "HOME_ASSISTANT"){funcionEjecucion="postHOMEASSISTANTCommand"}          
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "SHELLY"){funcionEjecucion="postSHELLYCommand"}          
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "ECOFORESTCONTROL"){funcionEjecucion="postECOFORESTCONTROLCommand"}          
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "BROADLINK"){funcionEjecucion="postBROADLINKCommand"}      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "IAQUALINK"){funcionEjecucion="postIAQUALINKCommand"}                      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "TAPO"){funcionEjecucion="postTAPOCommand"}                      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "MELCLOUD"){funcionEjecucion="postMELCLOUDCommand"}                      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "COMFORT_CLOUD"){funcionEjecucion="postCOMFORTCLOUDCommand"}                      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "MEROSS"){funcionEjecucion="postMEROSSCommand"}                      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "ONECTA_DAIKIN"){funcionEjecucion="postONECTADAIKINCommand"}                      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "GOVEE"){funcionEjecucion="postGOVEECommand"}                      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "XIAOMI"){funcionEjecucion="postXIAOMICommand"}                      
        else if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "SMARTTHINGS"){funcionEjecucion="postSMARTTHINGSCommand"}                      
        
        
        if(params.objDatosDispositivos[x]['TipoDispositivo'] === "PERSIANA"){
          listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|0\">Bajar "+params.objDatosDispositivos[x].Nombre+"</option>"
          listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|1\">Subir "+params.objDatosDispositivos[x].Nombre+"</option>"                  

          if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "SHELLY"){
            listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|modificarValor\">Cambiar valor de "+params.objDatosDispositivos[x].Nombre+"</option>"                  
          }

        }
        else if(params.objDatosDispositivos[x]['TipoDispositivo'] === "ESCENA"){
          listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|1\">Activar escena "+params.objDatosDispositivos[x].Nombre+"</option>"          
        }
        else if( (params.objDatosDispositivos[x]['TipoDispositivo'] === "SENSOR_TEMPERATURA") || (params.objDatosDispositivos[x]['TipoDispositivo'] === "SENSOR_HUMEDAD") ){
          // No muestro acciones porque son sensores          
        }  
        else if( (params.objDatosDispositivos[x]['TipoDispositivo'] === "AIRE_ACONDICIONADO") && (params.objDatosDispositivos[x]['MarcaDispositivo'] === "BROADLINK") ){
          listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|off\">Apagar "+params.objDatosDispositivos[x].Nombre+"</option>"
          listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|FRIO\">Encender "+params.objDatosDispositivos[x].Nombre+" en modo FRIO</option>"                
          listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|CALOR\">Encender "+params.objDatosDispositivos[x].Nombre+" en modo CALOR</option>"                
        }
        else if(params.objDatosDispositivos[x]['TipoDispositivo'].includes("LAVADORA")){
          // No muestro acciones porque son sensores          
          listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|1\">Poner a lavar "+params.objDatosDispositivos[x].Nombre+"</option>"          
        }  
        else{

          if(params.objDatosDispositivos[x]['MarcaDispositivo'] === "BROADLINK"){
            if( (params.objDatosDispositivos[x]['TipoDispositivo'] !== "SENSOR_TEMPERATURA") && (params.objDatosDispositivos[x]['TipoDispositivo'] !== "SENSOR_HUMEDAD") ){
              listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|0\">Apagar "+params.objDatosDispositivos[x].Nombre+"</option>"
              listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|1\">Encender "+params.objDatosDispositivos[x].Nombre+"</option>"               
            }  
          }
          else{

            if( (params.objDatosDispositivos[x]['Valor'] !== "") && (params.objDatosDispositivos[x]['Valor'] !== "N/A") ){
              listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|0\">Apagar "+params.objDatosDispositivos[x].Nombre+"</option>"
              listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|1\">Encender "+params.objDatosDispositivos[x].Nombre+"</option>"                  
              
              if( (params.objDatosDispositivos[x]['TipoDispositivo'] !== "ENCHUFE") && 
                  (params.objDatosDispositivos[x]['TipoDispositivo'] !== "TERMO") && 
                  (params.objDatosDispositivos[x]['TipoDispositivo'] !== "MONITOR_CONSUMO") ) {
                listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|modificarValor\">Cambiar valor de "+params.objDatosDispositivos[x].Nombre+"</option>"                  
              }
              

            }
            else{
              listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|0\">Apagar "+params.objDatosDispositivos[x].Nombre+"</option>"
              listadoAcciones += "<option value=\""+funcionEjecucion+"|"+params.objDatosDispositivos[x].IdDispositivo+"|1\">Encender "+params.objDatosDispositivos[x].Nombre+"</option>"                  
            }

            
          }

        }        

      }

    }else if(categoriaAccion === "Mensajeria"){								
      
      if( (params.ruleInfo.Rule.userTelegram !== null) && (params.ruleInfo.Rule.userTelegram !== "")){
        listadoAcciones += "<option value=\"Telegram|sendTelegram\" selected>Enviar mensaje a "+params.ruleInfo.Rule.userTelegram+" por Telegram</option>";				
      }
      
      try{
        var usuariosCompartidos = localStorage.getItem("sharedUsers").split("#")
        for(var n=0;n<usuariosCompartidos.length;n++){
          listadoAcciones += "<option value=\"Email|sendEmail···"+usuariosCompartidos[n]+"\">Enviar email a "+usuariosCompartidos[n]+"</option>";				            
        }
      }
      catch(error){}
      

    }else if(categoriaAccion === "RegistroActividad"){								
      listadoAcciones = "<option value=\"RegistroActividad|registerActivity\" selected>Registrar este evento en actividad</option>";				            
      document.getElementById("mensajeInformativoAccion"+params.actionInfo.actionId).innerHTML = "<p>Cuando esto suceda se registrará en el apartado de 'Actividad' con el nombre que le has puesto a esta regla. Recuerda que todas las acciones ya se registran automáticamente en actividad, así que esta opción es útil, por ejemplo, para <strong>probar el comportamiento de reglas</strong> antes de incluir las acciones reales.</p>"      
      document.getElementById("mensajeInformativoAccion"+params.actionInfo.actionId).className = document.getElementById("mensajeInformativoAccion"+params.actionInfo.actionId).className.replaceAll(" hidden", "")
      document.getElementById("fieldsetAcciones"+params.actionInfo.actionId).className += " hidden"      
    }

  document.getElementById("selectAcciones"+params.actionInfo.actionId).innerHTML = listadoAcciones
  
  actualizarValorAccion()

  }

  function actualizarValorAccion(){

    if(document.getElementById("selectAcciones"+params.actionInfo.actionId).value.includes("modificarAmperajeCarga")){      
      document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "1"
      document.getElementById("valorAccion"+params.actionInfo.actionId).value = ""      
      document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","")            
    }
    else if( document.getElementById("selectAcciones"+params.actionInfo.actionId).value === "Telegram|sendTelegram" ){      
      document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "3"
      document.getElementById("valorAccion"+params.actionInfo.actionId).value = ""      
      document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","")
    }
    else if( document.getElementById("selectAcciones"+params.actionInfo.actionId).value.includes("Email|sendEmail") ){      
      document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "3"
      document.getElementById("valorAccion"+params.actionInfo.actionId).value = ""      
      document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","")
    }
    else if(document.getElementById("selectAcciones"+params.actionInfo.actionId).value.includes("modificarValor")){
      document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "1"
      document.getElementById("valorAccion"+params.actionInfo.actionId).value = ""      
      document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","")            
    }
    else{      
      document.getElementById("valorAccion"+params.actionInfo.actionId).value = ""
      document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","") + " hidden"            
    }    

    var categoriaAccion = document.getElementById("selectBloquesAcciones"+params.actionInfo.actionId).value

    if(categoriaAccion === "Coche"){
      if( (document.getElementById("selectAcciones"+params.actionInfo.actionId).value.includes("iniciarCarga")) || (document.getElementById("selectAcciones"+params.actionInfo.actionId).value.includes("pararCarga")) || (document.getElementById("selectAcciones"+params.actionInfo.actionId).value.includes("modificarAmperajeCarga"))) {
        document.getElementById("divInfoCargaUbicacionCoche"+params.actionInfo.actionId).className = document.getElementById("divInfoCargaUbicacionCoche"+params.actionInfo.actionId).className.replaceAll(" hidden", "")
      }
      else{
        document.getElementById("divInfoCargaUbicacionCoche"+params.actionInfo.actionId).className = document.getElementById("divInfoCargaUbicacionCoche"+params.actionInfo.actionId).className.replaceAll(" hidden", "") + " hidden"
      }
    }
    else{
      document.getElementById("divInfoCargaUbicacionCoche"+params.actionInfo.actionId).className = document.getElementById("divInfoCargaUbicacionCoche"+params.actionInfo.actionId).className.replaceAll(" hidden", "") + " hidden"
    }

  }

  function setearValoresAccion(){

    cargarBloqueAcciones() 

    document.getElementById("selectBloquesAcciones"+params.actionInfo.actionId).value = params.actionInfo.action.split("|")[0]

    actualizarAccionesDisponibles()

    var elementosAccion = ""

    if(params.actionInfo.action.includes("modificarValor")){       

      elementosAccion = params.actionInfo.action.split("|")

      document.getElementById("selectAcciones"+params.actionInfo.actionId).value = elementosAccion[1]+"|"+elementosAccion[2]+"|"+elementosAccion[3]
      document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "1"
      document.getElementById("valorAccion"+params.actionInfo.actionId).value = params.actionInfo.action.split("|")[4]
      document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","")
    }
    else if( (params.actionInfo.action.includes("modificarCargaBateriasDeRed")) || (params.actionInfo.action.includes("forzarVentaExcedente")) ){

      elementosAccion = params.actionInfo.action.split("|")      
      
      document.getElementById("selectAcciones"+params.actionInfo.actionId).value = elementosAccion[1]+"|"+elementosAccion[2]+"|"+elementosAccion[3]+"|"+elementosAccion[4]
      document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "1"
      document.getElementById("valorAccion"+params.actionInfo.actionId).value = ""
      document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","") + " hidden"
    }
    else{

      var opcionAccion = params.actionInfo.action.split("|")[1]

      if( opcionAccion === "Telegram"){      
        opcionAccion += "|"+params.actionInfo.action.split("|")[2]      
      }
      else if( opcionAccion === "Email"){      

        try{          
          opcionAccion += "|"+params.actionInfo.action.split("|")[2]+"···"+params.actionInfo.action.split("|")[3].split("###")[0]
        }
        catch(error){
          opcionAccion += "|"+params.actionInfo.action.split("|")[2]     
        }


      }
      else if( opcionAccion === "RegistroActividad"){      
        opcionAccion += "|"+params.actionInfo.action.split("|")[2]      
      }
      else if( opcionAccion === "postTeslaCommand"){            
        opcionAccion += "|"+params.actionInfo.action.split("|")[2]     
      }
      else if( (opcionAccion === "updateTankLevelFull") || (opcionAccion === "updateTeslaData") ) {            
        // No cambia el valor
      }
      else{
        if(params.actionInfo.action.split("|")[2] !== ""){ opcionAccion += "|"+params.actionInfo.action.split("|")[2] }
        if(params.actionInfo.action.split("|")[3] !== ""){ opcionAccion += "|"+params.actionInfo.action.split("|")[3] }
      }

      if(document.getElementById("selectAcciones"+params.actionInfo.actionId).outerHTML.includes(opcionAccion)){

        document.getElementById("selectAcciones"+params.actionInfo.actionId).value = opcionAccion

        opcionAccion = params.actionInfo.action.split("|")[1]

        if( opcionAccion === "Telegram"){
          if(params.actionInfo.action.split("|")[2] === "sendTelegram"){        
            document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "3"
            document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","")          
            document.getElementById("valorAccion"+params.actionInfo.actionId).value = params.actionInfo.action.split("|")[3]                     
          }
        }
        else if( opcionAccion === "Email"){             
          if(params.actionInfo.action.split("|")[2] === "sendEmail"){
            document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "3"
            var mensaje = params.actionInfo.action.split("|")[3].split("###")[1]
            document.getElementById("valorAccion"+params.actionInfo.actionId).value = mensaje
            document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","")
          }
        }
        else if( opcionAccion === "postTeslaCommand"){  
          
            if(params.actionInfo.action.split("|")[2] === "modificarAmperajeCarga"){
              document.getElementById("valorAccion"+params.actionInfo.actionId).rows = "1"
              document.getElementById("valorAccion"+params.actionInfo.actionId).value = params.actionInfo.action.split("|")[3]
              document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","")
            }
        }
        else{
          document.getElementById("valorAccion"+params.actionInfo.actionId).value = ""
          document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className = document.getElementById("fieldsetValorAccion"+params.actionInfo.actionId).className.replaceAll(" hidden","") + " hidden"      
        }

      }
      else{
        if(opcionAccion.includes("Telegram")){
          initialConfigCommonJS.mostrarMensajeInformativo("Esta regla la creaste cuando tenías cuenta de Telegram configurada y ahora ya no tienes ninguna. Para que vuelva a estar operativa vuelve a configurarte una cuenta de telegram o modifica la acción, por ejemplo para que te avise por email y pulsa en 'Guardar'.","negative")
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo("Creaste esta regla con una configuración que ha cambiado en tu instalación. Comprueba que todas las aplicaciones de tus dispositivos inteligentes funcionan correctamente y si el problema persiste puedes dirigirte a nosotros en el apartado de 'Ayuda y soporte'.","negative")
        }
      }
    }
    
    if(params.actionInfo.frequency === undefined){      
      params.actionInfo.frequency = "0"            
    }    

    document.getElementById("selectFrecuenciaNotificacion"+params.actionInfo.actionId).value = params.actionInfo.frequency

  }

  function selectorDinamicoElementoRegla(elemento){

    document.getElementById("searchElementosReglas").value = ""
    rulesCommonJS.filtrarElementosSeleccionReglas()

    var elementoTemp = document.getElementById(elemento)

    if(elementoTemp.length >= 1){ //Tengo demasiada información, abro el menu lateral de filtrado
      elementoTemp.blur()
      params.visibilidadModalFiltradoDatos("abrir")
      
      // Aquí generar listado de elementos
      var listadoElementos = {
        "categoria": document.getElementById(elemento.replace("Acciones","BloquesAcciones")).value,
        "selectId": elemento,
        "valores": []
      }

      for(var x=0; x<elementoTemp.length; x++){       
        listadoElementos.valores.push({
          "valor": elementoTemp.options[x].value,
          "texto": elementoTemp.options[x].text
        })
      }

      params.setObjRuleElementSelector(listadoElementos)

    }

    //Si no opero directamente con los elementos de la select

  }

  return (    
    
    <section id={"detalleAccion"+params.actionInfo.actionId} className="bubble rule expanded">

      <button className="link expandable" onClick={ () => params.mostrarOcultarBloqueResumen("detalleAccion"+params.actionInfo.actionId)}>
        <span className="material-icon fold show-expanded">unfold_more</span>
        <span className="material-icon fold show-collapsed">unfold_less</span>
      </button>

      <fieldset className="detail">

        <fieldset className="dropdown">
          <label htmlFor={"labelBloquesAcciones"+params.actionInfo.actionId}>Bloques de acciones disponibles</label>
          <div className="icon-wrapper">
            <select id={"selectBloquesAcciones"+params.actionInfo.actionId} onChange={() => actualizarAccionesDisponibles()}/>
          </div>
        </fieldset>

        

        <fieldset id={"fieldsetAcciones"+params.actionInfo.actionId} className="dropdown" onClick={() => selectorDinamicoElementoRegla("selectAcciones"+params.actionInfo.actionId)}>
          <label htmlFor={"labelAcciones"+params.actionInfo.actionId}>Acción</label>
          <div className="icon-wrapper">
            <select id={"selectAcciones"+params.actionInfo.actionId} onChange={() => actualizarValorAccion()}/>
          </div>
        </fieldset>

        <div id={"divInfoCargaUbicacionCoche"+params.actionInfo.actionId} className="message info left hidden">            
          <div className="horizontal vertical-center">
            <span className="material-icon">info</span>
            <p>Este comando sólo se ejecutará si tu coche se encuentra en tu instalación.</p>
          </div>                
        </div>

        <fieldset id="fieldsetFrecuenciaNotificacion" className="dropdown" > 
          
          <label className="has-tooltip" htmlFor="selectFrecuenciaNotificacion">
            <span className="label tooltip-label">Frecuencia</span>
            <span className="tooltip-trigger">
              <span className="material-icon tooltip-icon link size-s">info</span>
              <span className="tooltip bottom">
                <span className="tooltip-container">
                  <p className="size-m tooltip-title">¿Frecuencia de ejecución?</p>
                  <p className="size-s">Siempre y cuando se cumplan las condiciones que has configurado esta acción se ejecutará con este espaciado de tiempo.</p>                  
                </span>
              </span>
            </span>
          </label>

          <div className="icon-wrapper">            
            <select id={"selectFrecuenciaNotificacion"+params.actionInfo.actionId} onBlur={ () => params.mostrarOcultarBloqueResumen("detalleAccion"+params.actionInfo.actionId)}>
              <option value="0">Siempre que se cumpla</option>
              <option value="300">Cada 5 minutos</option>
              <option value="600">Cada 10 minutos</option>
              <option value="900">Cada 15 minutos</option>
              <option value="1800">Cada 30 minutos</option>
              <option value="3600">Cada hora</option>
              <option value="7200">Cada 2 horas</option>
              <option value="14400">Cada 4 horas</option>
              <option value="28800">Cada 8 horas</option>
              <option value="43200">Cada 12 horas</option>
              <option value="86400">Una vez al día</option>
              <option value="2592000">Una vez al mes</option>
              <option value="31104000">Una vez al año</option>
            </select>
          </div>
        </fieldset> 

        <fieldset id={"fieldsetValorAccion"+params.actionInfo.actionId}>
          <label htmlFor={"labelValorAccion"+params.actionInfo.actionId}>Valor</label>
          <fieldset className="icon-wrapper data" data-label="">                 
            <textarea id={"valorAccion"+params.actionInfo.actionId} onBlur={ () => params.mostrarOcultarBloqueResumen("detalleAccion"+params.actionInfo.actionId)}/>
          </fieldset>
        </fieldset>

        <div className="actions">

        { params.actionInfo.actionId !== "1" ?
        <button id={"botonEliminar"+params.actionInfo.actionId} className="link delete" type="button" onClick={ () => params.eliminarAccion(params.actionInfo.actionId)}><span className="material-icon">remove_circle</span>Eliminar</button>
        : <></>
        }

        </div>

      </fieldset>

      <div id={"mensajeInformativoAccion"+params.actionInfo.actionId} className="size-s hidden">

      </div>

      <div className="summary horizontal gap-03 vertical-center" >
        <figure id={"figureIconoAccionRegla"+params.actionInfo.actionId} className="avatar size-m"><span id={"spanIconoAccionRegla"+params.actionInfo.actionId} className="material-icon"></span></figure>
        <h1 id={"resumenAccionesRegla"+params.actionInfo.actionId}> </h1>
      </div>

    </section>

  )
}

export default Action